export default {
  title: {
    id: 'profile_page_contact_details_tab_language_block_title',
    defaultMessage: 'Language',
  },
  description: {
    id: 'profile_page_contact_details_tab_language_block_description',
    defaultMessage: 'Choose your preferred language for all automated emails.',
  },
  updateButton: {
    id: 'profile_page_contact_details_tab_language_block_update_button_label',
    defaultMessage: 'Update',
  },
  languageUpdatedToastSuccess: {
    id: 'profile_page_contact_details_tab_language_block_update_success_toast',
    defaultMessage: 'Language updated ✔️',
  },
}
